<div class="main-container">
    <button class="tv-ns-secondary-large-button-on-light-bg left-margin-auto" (click)="onShowFilterDropDownButtonClick()">
        <mat-icon class="small-icon">visibility</mat-icon> Affichage
    </button>
    <div class="dropdown" [ngClass]="showDropDown ? 'visible-dropdown' : 'invisible-dropdown'">
        <h3 class="title">Colonnes</h3>
        <div class="horizontal-separator"></div>
        <div *ngFor="let filterItemToDisplay of filterItemsToDisplay">
            <mat-checkbox
                class="tv-ns-blue-checkbox"
                [checked]="filterItemToDisplay.isActive"
                (change)="onCheckBoxChange(filterItemToDisplay)"
                >{{ filterItemToDisplay.label }}</mat-checkbox
            >
        </div>
    </div>
</div>
